module.exports = __webpack_public_path__ + "img/surrender.3b4700f0.png";